import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Shield, Database, FileEdit, PlayCircle, ArrowLeft, ArrowRight, Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API } from "@/lib/newsUtils";

const SECTIONS = [
  {
    to: "/admin/datos",
    testid: "hub-datos",
    icon: Database,
    title: "Datos",
    desc: "Estadísticas y datos de los usuarios: medios seguidos, correo, registro y actividad.",
  },
  {
    to: "/admin/backoffice",
    testid: "hub-backoffice",
    icon: FileEdit,
    title: "BackOffice",
    desc: "Editor de contenido HTML de las páginas públicas de la web.",
  },
  {
    to: "/admin/test",
    testid: "hub-test",
    icon: PlayCircle,
    title: "Test",
    desc: "Prueba la primera entrada del usuario (tutorial) en modo sandbox. No guarda nada.",
  },
  {
    to: "/admin/feedback",
    testid: "hub-feedback",
    icon: Inbox,
    title: "Feedback",
    desc: "Bandeja de bugs y sugerencias enviados por los usuarios, con capturas adjuntas.",
  },
];

export default function AdminHub() {
  const navigate = useNavigate();
  const [newCount, setNewCount] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/admin/feedback`, { params: { status: "nuevo" } });
        setNewCount(data.new_count ?? 0);
      } catch { /* silencioso */ }
    })();
  }, []);
  return (
    <div className="min-h-screen bg-background" data-testid="admin-hub">
      <header className="sticky top-0 z-50 bg-background/90 backdrop-blur-xl border-b border-border">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-primary flex items-center justify-center">
              <Shield className="w-5 h-5 text-white" />
            </div>
            <h1 className="font-heading text-lg font-black tracking-tight">PANEL DE ADMINISTRACIÓN</h1>
          </div>
          <Button
            data-testid="admin-back-button"
            variant="outline"
            onClick={() => navigate("/")}
            className="rounded-none border-border h-10 w-10 px-0 sm:w-auto sm:px-4 gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="hidden sm:inline">Volver al feed</span>
          </Button>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
        <p className="text-xs uppercase tracking-widest text-muted-foreground font-medium mb-6">
          Elige una sección
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SECTIONS.map((s) => (
            <Link
              key={s.to}
              to={s.to}
              data-testid={s.testid}
              className="group border border-border p-6 hover:border-primary transition-colors flex flex-col"
            >
              <div className="w-12 h-12 bg-primary/10 flex items-center justify-center mb-5">
                <s.icon className="w-6 h-6 text-primary" />
              </div>
              <h2 className="font-heading text-xl font-black tracking-tight mb-2 flex items-center gap-2">
                {s.title}
                {s.testid === "hub-feedback" && newCount > 0 && (
                  <span
                    data-testid="hub-feedback-badge"
                    className="inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 bg-primary text-white text-xs font-bold rounded-full"
                  >
                    {newCount > 99 ? "99+" : newCount}
                  </span>
                )}
              </h2>
              <p className="text-sm text-muted-foreground flex-1">{s.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
                Entrar <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
